/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'

export default function ActAsPanda() {
  return (
    <svg viewBox="0 0 129 157" className="ActAs__panda">
      <path className="ActAs__panda-1" d="M125.68 154.71a61.07 61.07 0 0 0-122.11 0z" />
      <circle className="ActAs__panda-2" cx="104.62" cy="24.31" r="21.09" />
      <circle className="ActAs__panda-3" cx="104.62" cy="24.31" r="12" />
      <circle className="ActAs__panda-2" cx="24.62" cy="24.31" r="21.09" />
      <circle className="ActAs__panda-3" cx="24.62" cy="24.31" r="12" />
      <circle className="ActAs__panda-1" cx="64.62" cy="66.89" r="53.44" />
      <path d="M59.91 66.92l-5.53 7a6 6 0 0 0 4.71 9.72h11.06a6 6 0 0 0 4.71-9.72l-5.53-7a6 6 0 0 0-9.42 0z" />
      <path className="ActAs__panda-4" d="M59.39 76.92h10.47" />
      <path
        className="ActAs__panda-5"
        d="M79.12 66.64C71.66 54.33 74.55 44 82.89 41s18.77 0 23.1 9.31 2.67 21-3.33 25S85.92 79 79.12 66.64z"
      />
      <circle cx="87.8" cy="55.54" r="8.42" />
      <path
        className="ActAs__panda-6"
        d="M87.8 47.63a7.92 7.92 0 1 1-7.92 7.92 7.92 7.92 0 0 1 7.92-7.92m0-1a8.92 8.92 0 1 0 8.92 8.92 8.93 8.93 0 0 0-8.92-8.92z"
      />
      <circle className="ActAs__panda-7" cx="89.58" cy="52.93" r="2.62" />
      <path
        className="ActAs__panda-5"
        d="M50.12 66.64C57.59 54.33 54.69 44 46.36 41s-18.77 0-23.1 9.31-2.67 21 3.33 25S43.33 79 50.12 66.64z"
      />
      <circle cx="41.44" cy="55.54" r="8.42" />
      <path
        className="ActAs__panda-6"
        d="M41.44 47.63a7.92 7.92 0 1 1-7.92 7.92 7.92 7.92 0 0 1 7.92-7.92m0-1a8.92 8.92 0 1 0 8.92 8.92 8.93 8.93 0 0 0-8.92-8.92z"
      />
      <circle className="ActAs__panda-7" cx="43.66" cy="52.93" r="2.62" />
      <path className="ActAs__panda-5" d="M100.59 154.71a36 36 0 0 0-71.93 0z" />
    </svg>
  )
}
